import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=15ed0045&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=ts&"
export * from "./NoResults.vue?vue&type=script&lang=ts&"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=15ed0045&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed0045",
  null
  
)

export default component.exports